export default {"src":"/_next/static/media/logo.dd1d7705.svg","height":398,"width":2468,"blurWidth":0,"blurHeight":0};